module.exports = __webpack_public_path__ + "img/collection-play-fill.989172ba.svg";